import YouTubeIframeLoader from 'youtube-iframe'
import Velocity from 'velocity-animate'
import Screen from '../screen'

const screen = new Screen()
const youtubeBackground = () => {
  if (!screen.isPC) return

  let player
  const container = document.getElementById('yt-background')
  const videoId = container.dataset.yt_video_id

  YouTubeIframeLoader.load((YT) => {
    const buffering = document.getElementById('buffering')

    function removeBuffer() {
      Velocity(
        buffering,
        {
          opacity: 0,
        },
        {
          complete: () => {
            buffering.style.display = 'none'
          },
        },
        2000
      )
    }

    function onYoutubePlayerReady(e) {
      e.target.mute()
      e.target.playVideo()

      const promise = new Promise(resolve => {
        if (e.data === null) {
          e.target.playVideo()
          resolve('worked!')
        }
      })

      promise.then(() => {
        const promiseB = new Promise(resolve2 => {
          setTimeout(() => {
            resolve2('ready')
          }, 2000)
        })

        promiseB.then(() => {
          removeBuffer()
        })
      })
    }

    function onYoutubePlayerStateChange(e) {
      if (e.data === YT.PlayerState.ENDED) {
        if (window.getComputedStyle(buffering, null).display === 'block') {
          removeBuffer()
        }
      }
    }

    player = new YT.Player('yt-background', {
      videoId,
      width: '560',
      height: '315',
      playerVars: {
        cc_load_policy: 0,
        controls: 0,
        disablekb: 0,
        iv_load_policy: 3,
        playsinline: 1,
        rel: 0,
        showinfo: 0,
        modestbranding: 3,
        fs: 0,
        autoplay: 1,
        loop: 1,
        playlist: 'ijkeG7F56ww',
      },
      events: {
        onReady: onYoutubePlayerReady,
        onStateChange: onYoutubePlayerStateChange,
      },
    })

    return player
  })
}

export { youtubeBackground as default }
